import { AdvisorIcon, BrainIcon, GoalsIcon, DashboardsIcon } from "./icons"

interface NavIconProps {
  name: "advisor" | "brain" | "goals" | "dashboards"
  active?: boolean
  className?: string
}

export function NavIcon({ name, active, className }: NavIconProps) {
  const iconMap = {
    advisor: AdvisorIcon,
    brain: BrainIcon, // Brain icon with middle lines hover animation
    goals: GoalsIcon,
    dashboards: DashboardsIcon,
  }

  const IconComponent = iconMap[name]

  if (!IconComponent) {
    console.warn(`[NavIcon] Unknown icon name: ${name}`)
    return null
  }

  return (
    <div className="relative group">
      <IconComponent className={className} active={active} />
    </div>
  )
}
